import React from 'react'
import Link from 'next/link'
import { ChevronRight } from '@/components/svg'
import Type from '../Type'

interface Props {
  className?: string
  href: string
  text?: string
}

const BackLink: React.FC<Props> = ({ className, href, text = 'Back' }) => {
  return (
    <Link href={href} className={className}>
      <Type
        as="span"
        variant="caption-md"
        className="flex items-center text-core-oxide"
      >
        <ChevronRight className="w-4 rotate-180" /> {text}
      </Type>
    </Link>
  )
}

export default BackLink
